import { Paths } from "../app/settings/models/enviroment-consts/paths";

export const environment = {
  production: true,
  SECURITY: "ENV_DOMAIN/securityv2/v2/security",
  SECURITY_OIDC: "ENV_DOMAIN/securityv2/OIDC/v2.0",
  SITEKEYV2: "6LcVsp4mAAAAAOOqM6rAVpxhr93YLeeBX_5m5Map",
  CONTENT_MANAGEMENT: `ENV_DOMAIN${Paths.CONTENT_MANAGEMENT}`,
  WFU_ADPClient:  `ENV_DOMAIN${Paths.WFU_ADPClient}`,
  CHANNEL_STATUS: `ENV_DOMAIN${Paths.CHANNEL_STATUS}`,
  TOKEN_GUEST: `ENV_DOMAIN${Paths.TOKEN_GUEST}`,
  EXPIRED_TOKEN: "EXPIRED_TOKEN",
};
